import client from './client';

export const registerUser = async (email, username, password, avatar = 'potato_avatar_1.svg') => {
    const response = await client.post('/auth/register', { email, username, password, avatar });
    return response.data;
};

export const loginUser = async (emailOrUsername, password) => {
    const response = await client.post('/auth/login', { email: emailOrUsername, password });
    return response.data;
};

export const logoutUser = async () => {
    try {
        await client.post('/auth/logout', {});
    } catch (error) {
        // Ignore errors for logout.
    }
};

export const getAccount = async () => {
    const response = await client.get('/auth/account');
    return response.data;
};

export const updateAccount = async (updateData) => {
    const response = await client.put('/auth/account', updateData);
    return response.data;
};

export const changePassword = async (newPassword) => {
    const response = await client.put('/auth/account/password', { new_password: newPassword });
    return response.data;
};

export const verifyEmail = async (token, type = 'email') => {
    const response = await client.post('/auth/verify', { token, type });
    return response.data;
};
